export const component = state => state.component
export const property = state => state.property
